import { Observable } from 'rxjs';
import { catchErrorTypedAsync } from '../services/functions-helper.service';
import { IWSContext } from '../models/workspace/workspace-model';
import { IPaginationQuery } from '../models/defines';

export function handleApiCallAsync<T>(observable: Observable<T>) {
    const promise = new Promise<T>((resolve, reject) => {
        const subscription = observable.subscribe({
            next: (result: T) => {
                if (!result) {
                    reject(`An unknown error occurred`);
                } else {
                    return resolve(result);
                }
                subscription.unsubscribe();
                return;
            },
            error: (error) => {
                console.error(`An error occurred while processing the request. Error:`, error);
                reject(error);
                subscription.unsubscribe();
                return;
            },
        });
    });
    return catchErrorTypedAsync(promise);
}
export function getQueryString(pagination: IPaginationQuery | null) {
    const params: string[] = [];

    if (pagination?.limit) {
        params.push(`limit=${pagination.limit}`);
    }

    if (pagination?.page) {
        params.push(`page=${pagination.page}`);
    }
    const queryString = params.length ? `?${params.join('&')}` : '';
    return queryString;
}
export function deepUpdate<T>(target: T, source: T) {
    for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (isPlainObject(sourceValue) && isPlainObject(targetValue)) {
            deepUpdate(targetValue, sourceValue);
        } else if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
            syncArrays(targetValue, sourceValue);
        } else if (targetValue !== sourceValue) {
            target[key] = sourceValue;
        }
    }
}
function isPlainObject(value: any): value is Record<string, any> {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function syncArrays(targetArray: any[], sourceArray: any[]) {
    for (const sourceItem of sourceArray) {
        if (isPlainObject(sourceItem) && sourceItem.id != null) {
            const targetItem = targetArray.find((item) => item.id === sourceItem.id);
            if (targetItem) {
                deepUpdate(targetItem, sourceItem); // deeply update matching object
            } else {
                targetArray.push(structuredClone(sourceItem)); // add new item
            }
        } else {
            // For primitives or items without id, just add if not found
            const exists = targetArray.some((item) => item === sourceItem);
            if (!exists) {
                targetArray.push(sourceItem);
            }
        }
    }
}

export function assignDefined<T extends object>(target: T, source: Partial<T>) {
    for (const key in source) {
        const value = source[key];
        if (value !== undefined) {
            target[key] = value;
        }
    }
}
